// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__2nwDx","range":"MonthRangeSwitch_range__3U4Wp","disabled":"MonthRangeSwitch_disabled__3ni1s"};